import { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { CircleTick } from 'assets/icons';
import { ctaGreen, white } from 'constants/variables';
import Container from './shared/container';

const MarketoForm = ({ fields, ...rest }) => {
  const {
    title,
    formId,
    confirmationTitle,
    confirmationText,
    backgroundColor,
    alignment,
  } = fields;

  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    const loadMarketoForm = () => {
      if (typeof window.MktoForms2 !== 'undefined') {
        window.MktoForms2.setOptions({
          formXDPath: '/rs/050-FJS-973/images/marketo-xdframe-relative.html',
        });

        window.MktoForms2.loadForm(
          'https://go.cef.co.uk',
          '050-FJS-973',
          formId,
          form => {
            form.onSuccess(() => {
              if (isMounted) {
                setShowSuccessMsg(true);
                formRef.current?.scrollIntoView({ behavior: 'smooth' });
              }
              return false;
            });
          },
        );
      }
    };

    if (!document.getElementById('mktoForms2Script')) {
      const script = document.createElement('script');
      script.id = 'mktoForms2Script';
      script.src = '//go.cef.co.uk/js/forms2/js/forms2.min.js';
      script.async = true;
      script.onload = loadMarketoForm;
      document.body.appendChild(script);
    } else {
      loadMarketoForm();
    }

    return () => {
      isMounted = false;
    };
  }, [formId]);

  return (
    <FormContainer
      isFullWidth
      backgroundColor={backgroundColor}
      alignment={alignment}
      {...rest}>
      <FormWrapper className="evergreen__container-small" ref={formRef}>
        {title && <h2 className="fs-32 fw-800">{title}</h2>}

        {!showSuccessMsg ? (
          <form id={`mktoForm_${formId}`} className="evergreen__marketo-form" />
        ) : (
          <div
            className="marketo__form-wrapper"
            role="status"
            aria-live="polite">
            <div className="fl">
              <CircleTick
                width={40}
                height={40}
                fillColorMain={ctaGreen}
                fillColorSecondary={white}
              />
              <div className="ml-20">
                <h2 className="ff-body fw-600 fs-32 mb-20">
                  {confirmationTitle || 'Thank you for your submission'}
                </h2>
                <p className="ff-body fs-18">
                  {confirmationText || 'Your response has been recorded'}
                </p>
              </div>
            </div>
          </div>
        )}
      </FormWrapper>
    </FormContainer>
  );
};

const FormContainer = styled(Container)`
  text-align: ${({ alignment }) => alignment || 'left'};
`;

const FormWrapper = styled.div`
  text-align: left;
  display: inline-block;
`;

export default MarketoForm;
